module.exports = __webpack_public_path__ + "static/media/userAdd.5836a6d6.svg";